export default __webpack_public_path__ + "static/media/profile.8a701d40.jpg";